import { connectInput } from 'lib/form';
import { PasswordInput } from 'components/common';

const PasswordField = connectInput(PasswordInput);

export default PasswordField;
